document.addEventListener("DOMContentLoaded", () => {

let produitActif = "tetine";
let perleSelectionnee = null;
let couleurActive = "blanc";

const zones = {
    clips: document.getElementById("zone-clips"),
    tetine: document.getElementById("zone-tetine"),
    doudou: document.getElementById("zone-doudou"),
    porte7: document.getElementById("zone-porte7"),
    porte10: document.getElementById("zone-porte10")
};

const longueur = {
    clips: 0,
    tetine: 0,
    doudou: 0,
    porte7: 0,
    porte10: 0
};

const limites = {
    clips: 17,
    tetine: 17,
    doudou: 17,
    porte7: 7,
    porte10: 10
};

const prix = {
    clips: 17,
    tetine: 17,
    doudou: 19,
    porte7: 9.90,
    porte10: 9.90
};

function mettreAJourInterface(){

    const prixElement = document.getElementById("ec-prix");
    const longueurElement = document.getElementById("ec-longueur");
    const progress = document.getElementById("ec-progress");

    if(prixElement){

        prixElement.textContent =
        prix[produitActif].toFixed(2).replace(".",",") + " €";

    }

    if(longueurElement){

        longueurElement.textContent =
        longueur[produitActif].toFixed(1) +
        " / " +
        limites[produitActif] +
        " cm";

    }

    if(progress){

        progress.style.width =
        ((longueur[produitActif]/limites[produitActif])*100)+"%";

    }

}

document.querySelectorAll(".ec-produit").forEach((btn)=>{

    btn.addEventListener("click",()=>{

        document.querySelectorAll(".ec-produit").forEach((b)=>{

            b.classList.remove("active");

        });

        btn.classList.add("active");

        produitActif = btn.dataset.zone;

        mettreAJourInterface();

    });

});

function selectionnerPerle(perle){

    document.querySelectorAll(".perle-photo, .clip-photo").forEach((p)=>{
        p.classList.remove("perle-active");
    });

    perle.classList.add("perle-active");

    perleSelectionnee = perle;

    if (perle.classList.contains("clip-photo")) {
        document.getElementById("ec-outils-clip").style.display = "flex";
        document.getElementById("ec-outils-perle").style.display = "none";
    } else {
        document.getElementById("ec-outils-perle").style.display = "flex";
        document.getElementById("ec-outils-clip").style.display = "none";
    }

}


function ajouterPerle(src){

    const taillePerle = 1.2;

if(longueur[produitActif] + taillePerle > limites[produitActif]){
    alert("Longueur maximale atteinte");
    return;
}

    const perle = document.createElement("img");

    perle.src = src;
    perle.className = "perle-photo";

    perle.addEventListener("click",()=>{

        selectionnerPerle(perle);

    });

    zones[produitActif].appendChild(perle);

    longueur[produitActif] += 1.2;

    mettreAJourInterface();

}

document.querySelectorAll(".lettre").forEach((btn)=>{

    btn.addEventListener("click",()=>{

        const img = btn.querySelector("img");

        if(!img) return;

        ajouterPerle(img.src);

    });

});

document.querySelectorAll(".ec-couleur").forEach((btn)=>{

    btn.addEventListener("click",()=>{

        document.querySelectorAll(".ec-couleur").forEach((b)=>{

            b.classList.remove("active");

        });

        btn.classList.add("active");

        couleurActive = btn.dataset.couleur;

        document.querySelectorAll("#grille-lettres img").forEach((img)=>{

            if(couleurActive==="blanc"){

                img.src = img.dataset.blanc;

            }else if(couleurActive==="beige"){

                img.src = img.dataset.beige;

            }else{

                img.src = img.dataset.noir;

            }

        });

    });

});
document.querySelectorAll(
"#grille-clips .clip, #grille-clips-fantaisie .clip, #grille-perles-fantaisie .clip, #grille-perles-fleurs .clip, #grille-perles-feuilles .clip, #grille-perles-diverses .clip, #grille-perles-motif .clip, #grille-perles-unies .clip, #grille-perles-espacement .clip, #grille-perles-citrouille .clip, #grille-perles-hexagonales .clip"
).forEach((btn)=>{

    btn.addEventListener("click",()=>{

        const img = btn.querySelector("img");

        if(!img) return;

        const clip = document.createElement("img");

clip.src = img.src;

if (
  btn.closest("#grille-perles-fantaisie") ||
  btn.closest("#grille-perles-fleurs") ||
  btn.closest("#grille-perles-feuilles") ||
  btn.closest("#grille-perles-diverses")
){
  clip.className = "perle-photo perle-fantaisie";
}
else if (
    btn.closest("#grille-perles-motif") ||
    btn.closest("#grille-perles-citrouille") ||
    btn.closest("#grille-perles-hexagonales")
){
    clip.className = "perle-photo perle-motif";
}
else if (btn.closest("#grille-perles-unies")){
  clip.className = "perle-photo perle-unie";
}
else if (btn.closest("#grille-perles-espacement")){
    clip.className = "perle-photo perle-espacement";
    clip.style.marginLeft = "-4px";
    clip.style.marginRight = "-4px";
}
else{
  clip.className = "clip-photo";
}
    clip.addEventListener("click",(e)=>{

    e.stopPropagation();


    selectionnerPerle(clip);

});
if(clip.classList.contains("perle-photo")){

    const zone = zones[produitActif];
const taille =
    clip.classList.contains("perle-fantaisie") ? 2 :
    clip.classList.contains("perle-motif") ? 1.5 :
    clip.classList.contains("perle-citrouille") ? 1.5 :
    clip.classList.contains("perle-unie") ? 1.5 :
    clip.classList.contains("perle-espacement") ? 0.1 :
    1.2;
if(longueur[produitActif] + taille > limites[produitActif]){
    alert("Longueur maximale atteinte");
    return;
}
   if (zone) {
    zone.appendChild(clip);

    if (clip.classList.contains("perle-fantaisie")) {
    longueur[produitActif] += 2;
}
else if (
    clip.classList.contains("perle-motif") ||
    clip.classList.contains("perle-citrouille") ||
    clip.classList.contains("perle-hexagonale")
) {
    longueur[produitActif] += 1.5;
}
else if (clip.classList.contains("perle-unie")) {
    longueur[produitActif] += 1.5;
}
else if (clip.classList.contains("perle-espacement")) {
    longueur[produitActif] += 0.3;
}
else {
    longueur[produitActif] += 1.2;
}

    mettreAJourInterface();
}

    return;
}
       if (produitActif === "doudou") {

    const zoneGauche = document.getElementById("zone-clip-gauche");
    const zoneDroite = document.getElementById("zone-clip-droite");

    if (zoneGauche && zoneDroite) {

        zoneGauche.innerHTML = "";
        zoneDroite.innerHTML = "";

        const clipGauche = clip.cloneNode(true);
        const clipDroite = clip.cloneNode(true);

        clipGauche.className = "clip-photo";
        clipDroite.className = "clip-photo";

        clipGauche.addEventListener("click",(e)=>{
            e.stopPropagation();
            selectionnerPerle(clipGauche);
        });

        clipDroite.addEventListener("click",(e)=>{
            e.stopPropagation();
            selectionnerPerle(clipDroite);
        });

        zoneGauche.appendChild(clipGauche);
        zoneDroite.appendChild(clipDroite);

    }

} else {

    if (clip.classList.contains("clip-photo")) {

        const zoneClip = document.getElementById("zone-clips");

        if (zoneClip) {
            zoneClip.innerHTML = "";
            zoneClip.appendChild(clip);
        }

    } else {

        const zone = zones[produitActif];

        if (zone) {

            zone.appendChild(clip);
            longueur[produitActif] += 1.2;
            mettreAJourInterface();

        }

    }

}

    });

});

const reset = document.getElementById("ec-reset");

if(reset){

    reset.addEventListener("click",()=>{

        Object.values(zones).forEach((zone)=>{

            if(zone){

                zone.innerHTML = "";

            }

        });

        Object.keys(longueur).forEach((cle)=>{

            longueur[cle] = 0;

        });

        perleSelectionnee = null;

        mettreAJourInterface();

    });

}
document.getElementById("move-left")?.addEventListener("click",()=>{

    if(!perleSelectionnee) return;

    const precedente = perleSelectionnee.previousElementSibling;

    if(precedente){

        perleSelectionnee.parentNode.insertBefore(
            perleSelectionnee,
            precedente
        );

    }

});

document.getElementById("move-right")?.addEventListener("click",()=>{

    if(!perleSelectionnee) return;

    const suivante = perleSelectionnee.nextElementSibling;

    if(suivante){

        suivante.parentNode.insertBefore(
            suivante,
            perleSelectionnee
        );

    }

});

document.getElementById("delete-perle")?.addEventListener("click",()=>{

    if(!perleSelectionnee) return;

    const parent = perleSelectionnee.parentNode;

    if(parent && parent.id !== "zone-clips"){

        if (perleSelectionnee.classList.contains("perle-fantaisie")) {
    longueur[produitActif] -= 2;
} else {
    longueur[produitActif] -= 1.2;
}

        if(longueur[produitActif] < 0){
            longueur[produitActif] = 0;
        }

    }

    perleSelectionnee.remove();
    perleSelectionnee = null;

    afficherOutils();
    mettreAJourInterface();

});
function afficherOutils(){

    const outilsPerle = document.getElementById("ec-outils-perle");
    const outilsClip = document.getElementById("ec-outils-clip");

    if(!perleSelectionnee){

        outilsPerle.style.display = "flex";
        outilsClip.style.display = "none";
        return;

    }

    if(perleSelectionnee.classList.contains("clip-photo")){

        outilsPerle.style.display = "none";
        outilsClip.style.display = "flex";

    }else{

        outilsPerle.style.display = "flex";
        outilsClip.style.display = "none";

    }

}
document.querySelectorAll("#grille-perles-motif .perle").forEach((btn)=>{

    btn.addEventListener("click",()=>{

        const img = btn.querySelector("img");

        if(!img) return;

        ajouterPerle(img.src);

    });

});
document.querySelectorAll(".perle-photo").forEach((perle)=>{

    perle.addEventListener("click",()=>{

        selectionnerPerle(perle);
        afficherOutils();

    });

});

document.addEventListener("click",(e)=>{

    if(
        !e.target.closest(".perle-photo") &&
        !e.target.closest(".clip-photo") &&
        !e.target.closest("#ec-outils-perle") &&
        !e.target.closest("#ec-outils-clip")
    ){

        document.querySelectorAll(".perle-photo, .clip-photo").forEach((p)=>{
            p.classList.remove("perle-active");
        });

        perleSelectionnee = null;

        afficherOutils();

    }

});
document.getElementById("btn-pivoter")?.addEventListener("click", () => {

    if (!perleSelectionnee) return;

    if (
        perleSelectionnee.classList.contains("perle-fantaisie")
    ) {

        let rotation = parseInt(perleSelectionnee.dataset.rotation || "0");

        rotation += 90;

        perleSelectionnee.dataset.rotation = rotation;

        perleSelectionnee.style.transform = `rotate(${rotation}deg)`;

    }

});
document.getElementById("delete-clip")?.addEventListener("click",()=>{

    if(!perleSelectionnee) return;

if(
    perleSelectionnee.parentNode.id === "zone-clips" ||
    perleSelectionnee.parentNode.id === "zone-clip-gauche" ||
    perleSelectionnee.parentNode.id === "zone-clip-droite"
){

        perleSelectionnee.remove();

        perleSelectionnee = null;

        document.getElementById("ec-outils-clip").style.display = "none";

    }

});
afficherOutils();


mettreAJourInterface();
const variantes = {
    tetine: 64930726314333,
    doudou: 65123984507229,
    porte7: 65123985391965,
    porte10: 65123986735453
};

document.getElementById("ec-add-cart")?.addEventListener("click", async () => {

    const idVariante = variantes[produitActif];

    if (!idVariante) {
        alert("Produit introuvable.");
        return;
    }

const composition = [];

// Ajout du ou des clips
[
  "zone-clips",
  "zone-clip-gauche",
  "zone-clip-droite"
].forEach(id => {
  const zoneClip = document.getElementById(id);

  if (zoneClip) {
    zoneClip.querySelectorAll("img").forEach(img => {

      const nom =
        img.dataset.nom ||
        img.alt ||
        img.getAttribute("title") ||
        img.src.split("/").pop().split(".")[0];

      composition.push("Clip : " + nom);
    });
  }
});

const zone = zones[produitActif];
if (zone) {

    zone.querySelectorAll("img").forEach((img) => {

        const nom =
            img.dataset.nom ||
            img.alt ||
            img.getAttribute("title") ||
            img.src.split("/").pop().split(".")[0];

        composition.push(nom);

    });

}

const properties = {

    Produit: produitActif,

    Longueur: longueur[produitActif].toFixed(1) + " cm",

    Composition: composition.join("\r\n")

};

    const reponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            id: idVariante,
            quantity: 1,
            properties: properties
        })
    });

    if (reponse.ok) {
        window.location.href = "/cart";
    } else {
        alert("Erreur lors de l'ajout au panier.");
    }

});

});